import { byMedia } from '../helpers/media';
export const backgroundColor = byMedia(value => `background-color: ${value};`);